/*
import useBasket from '@/stores/Basket';

export default class Helper {
  static vatPrice(price, vat = 0) {
    price = parseFloat(price);
    vat = parseFloat(vat);

    return price + (price * vat) / 100;
  }

  static formatPrice(price, showFloat) {
    const decimal = 2;
    price = price.toString();

    if (typeof showFloat === 'undefined') {
      const { getSettings } = useBasket();
      showFloat = !!getSettings('priceFloat');
    }

    const pricePow = Math.pow(10, decimal);
    const roundedPrice = Math.round(price * pricePow) / pricePow;

    if (showFloat) {
      const v = roundedPrice.toString().split('.');

      if (decimal <= 0) return v[0];
      let f = v[1] || '';
      while (f.length < decimal) f += '0';

      return `${v[0]}.${f}`;
    }

    return roundedPrice;
  }

  static removeVatPrice(price, vat = 0) {
    price = parseFloat(price);
    vat = parseFloat(vat);

    return price / ((100 + vat) / 100);
  }

  static resizeImage(url, width, height, crop = 0) {
    url = url.replace('userfiles/', '');
    return `get/image/${width}/${height}/${crop}/${url}`;
  }
}
*/

export function resizeImage(url, settings) {
  return `get/image/${url}?${new URLSearchParams(settings)}`;
}

export function formatPrice(price, showFloat) {
  const decimal = 2;
  price = price.toString();

  const pricePow = Math.pow(10, decimal);
  const roundedPrice = Math.round(price * pricePow) / pricePow;

  if (showFloat) {
    const v = roundedPrice.toString().split('.');

    if (decimal <= 0) return v[0];
    let f = v[1] || '';
    while (f.length < decimal) f += '0';

    return `${v[0]}.${f}`;
  }

  return roundedPrice;
}
